export default __webpack_public_path__ + "static/marketing-gallery-4e47157639848937d641d57183a0221e.jpg";